<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18GIVzC/tc-custom/9781439672341.jpg?1737918820149" alt="This image is the cover for the book Strange Tales from Virginia's Mountains"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strange Tales from Virginia's Mountains
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Explore the mysterious side of Virginia with these strange tales of Bigfoot, buried treasure, phantom dogs, UFOs, ghosts, and more.</b></p> The stunning mountains of Virginia offer spectacular views and endless outdoor activities, yet they also hold secrets. A nineteenth-century cache of gold is buried in the hills. Nine-foot giants once walked the ridges, pre-Columbian explorers built homes on isolated mountaintops and a ghost town lies deep in the Jefferson National Forest. The mountains conceal canines that walk upright, black panthers and a resurgent mountain lion population. The hide-and-seek champion of the world, Bigfoot, lurks in the dark hollows, phantom dogs pace the back roads and aggressive monkeys swing through the trees. UFOs crisscross the skies, and ghosts haunt the caverns below. Join Denver Michaels, local author and explorer of the unexplained, as he explores these mysteries and many more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denver Michaels
      </h2>
      
      <p class="authorDescription body article">Denver Michaels is an author with a passion for cryptozoology, the paranormal, lost civilizations & ancient history, and all things unexplained. In 2016, the Virginia native released his first book, People are Seeing Something, which makes a case for the existence of lake monsters in the United States and Canada. Since then, he has gone on to author several other books covering various cryptids and paranormal subject matter. Michaels and his wife sold their home in the summer of 2020, and now travel the country full-time in an RV. Michaels enjoys the outdoors, hiking, fishing, investigating the unexplained, and working on new writing projects.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c6e2bed2